// Description: Endpoint to get the ModeGraphic data
// Updated:
// Author: Simon Franklin

import axios from "axios";
import { getTokenData } from "../../../shared/utils/utils";
import use123zapStore from "../../../context/123zapStore";


export const GetModeGraphicData = async (start_date, end_date) => {

    try {
        const url = process.env.REACT_APP_BACKEND_AWS_URL;
        const { token, client_id } = await getTokenData();

        if (!token) {
            throw new Error('Token de autenticação não encontrado');
        }

        if (!client_id) {
            throw new Error('ID do cliente não encontrado');
        }

        const response = await axios
            .post(`${url}/dashboard/messages/sent/monthly`, {
                start_date,
                end_date,
                "refresh": true
            }, {
                headers: { Authorization: token, "Client_ID": client_id },
            })

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar dados do gráfico:', error.message);

        throw error;
    }
}